enum REDIRECT_AFTER_LOGIN_GUEST{
  RETRO,
  POKER
}

export {
  REDIRECT_AFTER_LOGIN_GUEST,
};
